export default "__VITE_ASSET__CK9Afr2b__"